interface ITypeformData {
  "first_last_name": string,
  "is_sitelink_set_up": string,
  "is_typeform": boolean,
  "landed_at": any,
  "location_access_hours": string,
  "location_additional_emails": string,
  "location_additional_features": string,
  "location_address_1": string,
  "location_address_2": string,
  "location_billing_type": string,
  "location_current_ads": string,
  "location_email": string,
  "location_enable_rentals": boolean,
  "location_enable_reservations": boolean,
  "location_features": string[],
  "location_insurance": string,
  "location_locale_names": string,
  "location_moving_supplies": boolean,
  "location_name": string,
  "location_number_employees": number,
  "location_number_of_units": number,
  "location_occupancy_percentage": number,
  "location_office_hours": string,
  "location_phone_number": string,
  "location_social_media_types": string[],
  "location_software": string,
  "location_storage_types": string[],
  "location_tagline": string,
  "location_when_established": string,
  "is_location_rentals_days_in_advance": boolean,
  "location_rentals_days_in_advance": number,
  "is_location_reservations_days_in_advance": boolean,
  "location_reservations_days_in_advance": number,
  "manager_full_name": string,
  "notes": string,
  "sitelink_corp_code"?: string,
  "sitelink_location_code"?: string,
  "sitelink_password"?: string,
  "sitelink_user_name"?: string,
  "submitted_at": any,
  "submitter_email": string,
  "website_url": string
}

export class TypeformLocationOnboarding {
  locationKey?: string;
  isTypeform = true;
  fullName: string;
  locationName: string;
  tagline: string;
  managersName: string;
  numUnits: number;
  numEmployees: number;
  occupancyRate: string;
  email: string;
  additionalEmails: string;
  phone: string;
  address1: string;
  address2: string;
  // alias for officeHours
  hours: string;
  officeHours: string;
  accessHours: string;
  isSitelinkReady: boolean;
  sitelinkCorpCode: string;
  sitelinkLocationCode: string;
  sitelinkUserName: string;
  sitelinkPassword: string;
  socialMedia: string;
  showSocialLinks = false;
  features: string[];
  additionalFeatures: string;
  isInsurance: boolean;
  isInsuranceRequired: boolean;
  isEnableRentals: boolean;
  isRentalsDaysInAdvance: boolean;
  rentalsDaysInAdvance: number;
  isEnableReservations: boolean;
  isReservationsDaysInAdvance: boolean;
  reservationsDaysInAdvance: number;
  software: string;
  localeNames: string;
  established: string;
  storageTypes: string[];

  isFb = false;
  fbUrl: string = '';
  isTwitter = false;
  twitterUrl: string = '';
  isYelp = false;
  yelpUrl: string = '';
  isGoogle = false;
  google: string = '';
  isLinkedIn = false;
  linkedIn: string = '';
  isInsta = false;
  insta: string = '';
  isOther = false;
  otherSocial: string = '';

  submittedAt: Date;
  landedAt: Date;

  id: string;
  origKey: string;

  constructor(data: ITypeformData, id, origKey) {
    this.id = id;
    this.origKey = origKey;
    this.fullName = data.first_last_name || '';
    this.managersName = data.manager_full_name || '';
    this.numEmployees = data.location_number_employees || 0;
    this.numUnits = data.location_number_of_units || 0;
    this.occupancyRate = `${ String(data.location_occupancy_percentage || 0) }%`;
    this.locationName = data.location_name || '';
    this.tagline = data.location_tagline || '';
    this.email = data.location_email || '';
    if (data.location_additional_emails) {
      try {
        this.additionalEmails = data.location_additional_emails.replace(/\s/g, '');
      }
      catch (error) {
        console.warn('error caught adding additional emails:', error);
      }
    }
    if (data.location_phone_number && data.location_phone_number.includes('+1')) {
      this.phone = data.location_phone_number.replace(/\+1/, '');
    }
    else {
      this.phone = data.location_phone_number || '';
    }
    this.address1 = data.location_address_1 || '';
    this.address2 = data.location_address_2 || '';
    this.hours = data.location_office_hours || '';
    this.officeHours = data.location_office_hours || '';
    this.accessHours = data.location_access_hours || '';
    this.isSitelinkReady = !!data.is_sitelink_set_up && data.is_sitelink_set_up.includes('Yes');
    if (this.isSitelinkReady) {
      this.sitelinkCorpCode = data.sitelink_corp_code;
      this.sitelinkLocationCode = data.sitelink_location_code;
      this.sitelinkUserName = data.sitelink_user_name;
      this.sitelinkPassword = data.sitelink_password;
    }
    this.features = data.location_features || [];
    this.additionalFeatures = data.location_additional_features || '';
    this.isInsurance = !!data.location_insurance && data.location_insurance.includes('Yes');
    this.isInsuranceRequired = this.isInsurance && data.location_insurance.includes('Required');
    this.isEnableRentals = !!data.location_enable_rentals;
    this.isRentalsDaysInAdvance = !!data.is_location_rentals_days_in_advance;
    this.rentalsDaysInAdvance = data.location_rentals_days_in_advance || 0;
    this.isEnableReservations = !!data.location_enable_reservations;
    this.isReservationsDaysInAdvance = !!data.is_location_reservations_days_in_advance;
    this.reservationsDaysInAdvance = data.location_reservations_days_in_advance || 0;
    this.software = data.location_software || '';
    this.localeNames = data.location_locale_names || '';
    this.established = data.location_when_established || '';
    this.storageTypes = data.location_storage_types || [];
    this.submittedAt = new Date(data.submitted_at);
    this.landedAt = new Date(data.landed_at);

    /**
     * location_allow_gate_code
     * location_gate_code_min_length
     * location_gate_code_max_length
     * location_gate_code_special_rules
     * location_rentals_confirmation_message
     * location_reservation_confirmation_message
     * location_top_three_features
     * location_welcome_paragraph
     * location_about
     */

    if (data.location_social_media_types) {
      this.isFb = data.location_social_media_types.includes('Facebook');
      this.isYelp = data.location_social_media_types.includes('Yelp');
      this.isGoogle = data.location_social_media_types.includes('Google My Business');
      this.isLinkedIn = data.location_social_media_types.includes('LinkedIn');
      this.isInsta = data.location_social_media_types.includes('Instagram');
      this.isTwitter = data.location_social_media_types.includes('Twitter');
      this.showSocialLinks = this.isFb || this.isYelp || this.isGoogle || this.isLinkedIn || this.isInsta || this.isTwitter;
    }
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/typeform-location-from-onboarding.ts